import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { TextField } from '@material-ui/core';
import { formatHHMM, parseHHMM } from '@/utilities/hhmm';

// Editable service time as HH:MM (stored/committed as whole minutes). Holds its own
// text state and commits the parsed value on blur, so we don't reparse mid-type or
// fire a write per keystroke. Reseeds when the stored value changes underneath it.
const ServiceTimeInput = ({ value, onCommit, ariaLabel, width = 90 }) => {
    const stored = Number.isFinite(value) ? value : null;
    const [text, setText] = useState(formatHHMM(stored));

    useEffect(() => {
        setText(formatHHMM(stored));
    }, [stored]);

    const commit = () => {
        const next = parseHHMM(text);
        // Unparseable non-empty text is a typo, not an intentional clear -- revert to the
        // stored value instead of committing a null over it. Only an empty field clears.
        if (next == null && text.trim() !== '') {
            setText(formatHHMM(stored));
            return;
        }
        setText(formatHHMM(next));
        if (next !== stored) onCommit(next);
    };

    return (
        <TextField
            size="small"
            variant="outlined"
            placeholder="HH:MM"
            value={text}
            inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
            onChange={(e) => setText(e.target.value)}
            onBlur={commit}
            css={css`
                width: ${width}px;
            `}
        />
    );
};

export default ServiceTimeInput;
